import {useIntl} from 'react-intl';
import classNames from 'classnames';

import {IconButton} from '@time-webkit/all/atoms/icon-button';

import {sendToStatist} from 'packages/statist';

import {useSendButtonIcons} from './use-send-button-icons';
import {useButtonTooltip} from './use-button-tooltip';

import {type Props} from './types';

import styles from './styles.module.css';

export function SendButton(props: Props) {
    const {
        isEdit = false,
        loading = false,
        isDisabled = false,
        isRightButtonEnabled = false,
        onPress,
        renderWithMenuWrapper,
    } = props;

    const {formatMessage} = useIntl();
    const {
        rightButtonIcon,
        leftButtonIcon,
        isRightButtonActive,
        setIsRightButtonActive,
    } = useSendButtonIcons({isEdit, loading});
    const {renderWithTooltip: renderLeftButtonWithTooltip} = useButtonTooltip({
        tooltipText: isEdit ? (
            formatMessage({id: 'create_post.save_message', defaultMessage: 'Save changes'})
        ) : formatMessage({id: 'create_post.send_message', defaultMessage: 'Send message'}),
        isDisabled,
    });
    const {renderWithTooltip: renderRightButtonWithTooltip} = useButtonTooltip({
        tooltipText: formatMessage({id: 'create_post.send_later', defaultMessage: 'Send later'}),
        isDisabled,
    });

    const showSecondaryButton = !isEdit && !loading && isRightButtonEnabled && renderWithMenuWrapper;

    return (
        <div className={styles.wrapper}>
            {renderLeftButtonWithTooltip(
                <IconButton
                    isDisabled={isDisabled}
                    onPress={onPress}
                    icon={leftButtonIcon}
                    className={classNames(styles.button, {
                        [styles.leftButton]: showSecondaryButton,
                        [styles.editButton]: isEdit,
                    })}
                    focusRingClass={styles.focused}
                    aria-label={'Send a message'}
                />,
            )}
            {showSecondaryButton && (
                <span
                    tabIndex={-1}
                    className={classNames(styles.divider, {
                        [styles.disabledDivider]: isDisabled,
                    })}
                />
            )}
            {showSecondaryButton && renderWithMenuWrapper(
                renderRightButtonWithTooltip(
                    <IconButton
                        onPress={() => sendToStatist('editor.sendLater.tap')}
                        isDisabled={isDisabled}
                        icon={rightButtonIcon}
                        className={classNames(styles.rightButton, {
                            [styles.active]: isRightButtonActive,
                        })}
                        focusRingClass={styles.focused}
                        aria-label={'Send later'}
                    />,
                ),
                setIsRightButtonActive,
            )}
        </div>
    );
}
